import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import config from "../config/config.json";
import "../styles/FaqSection.css";
import { useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useLocation } from "react-router-dom";
import ConstructionTable1 from "../ConstructionTables/Cn_Table1";
import ConstructionTable2 from "../ConstructionTables/Cn_Table2";
import ConstructionTable3 from "../ConstructionTables/Cn_Table3";
import ConstructionTable4 from "../ConstructionTables/Cn_Table4";
import ConstructionTable5 from "../ConstructionTables/Cn_Table5";
import ConstructionTable6 from "../ConstructionTables/Cn_Table6";
import ConstructionTable7 from "../ConstructionTables/Cn_Table7";
import ConstructionTable8 from "../ConstructionTables/Cn_Table8";
import ConstructionTable9 from "../ConstructionTables/Cn_Table9";
import ConstructionTable10 from "../ConstructionTables/Cn_Table10";
import ConstructionTable11 from "../ConstructionTables/Cn_Table11";
import ConstructionTable12 from "../ConstructionTables/Cn_Table12";
import ConstructionTable13 from "../ConstructionTables/Cn_Table13";
import ConstructionTable14 from "../ConstructionTables/Cn_Table14";
import ConstructionTable15 from "../ConstructionTables/Cn_Table15";
import ConstructionTable16 from "../ConstructionTables/Cn_Table16";
import ConstructionTable17 from "../ConstructionTables/Cn_Table17";
import ConstructionTable18 from "../ConstructionTables/Cn_Table18";
import ConstructionTable19 from "../ConstructionTables/Cn_Table19";
import ConstructionTable20 from "../ConstructionTables/Cn_Table20";
import ConstructionTable21 from "../ConstructionTables/Cn_Table21";
import ConstructionTable22 from "../ConstructionTables/Cn_Table22";
import ConstructionTable23 from "../ConstructionTables/Cn_Table23";
import ConstructionTable24 from "../ConstructionTables/Cn_Table24";

export const ConstructionFaq = ({ searchTerm }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Employment-Trend");

  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [data_cv_q1, set_data_cv_q1] = useState([]);
  const [data_cv_q2, set_data_cv_q2] = useState([]);
  const [data_cv_q3, set_data_cv_q3] = useState([]);
  const [data_cv_q4, set_data_cv_q4] = useState([]);
  const [data_cv_q5, set_data_cv_q5] = useState([]);
  const [data_cv_q6, set_data_cv_q6] = useState([]);
  const [data_cv_q7, set_data_cv_q7] = useState([]);
  const [data_cv_q8, set_data_cv_q8] = useState([]);
  const [data_cv_q9, set_data_cv_q9] = useState([]);
  const [data_cv_q10, set_data_cv_q10] = useState([]);
  const [data_cv_q11, set_data_cv_q11] = useState([]);
  const [data_cv_q12, set_data_cv_q12] = useState([]);
  const [data_cv_q13, set_data_cv_q13] = useState([]);
  const [data_cv_q14, set_data_cv_q14] = useState([]);
  const [data_cv_q15, set_data_cv_q15] = useState([]);
  const [data_cv_q16, set_data_cv_q16] = useState([]);
  const [data_cv_q17, set_data_cv_q17] = useState([]);
  const [data_cv_q18, set_data_cv_q18] = useState([]);
  const [data_cv_q19, set_data_cv_q19] = useState([]);
  const [data_cv_q20, set_data_cv_q20] = useState([]);
  const [data_cv_q21, set_data_cv_q21] = useState([]);
  const [data_cv_q22, set_data_cv_q22] = useState([]);
  const [data_cv_q23, set_data_cv_q23] = useState([]);
  const [data_cv_q24, set_data_cv_q24] = useState([]);

  // Helper function to process data and ensure numeric values are properly parsed
  const processNumericData = (data) => {
    if (!Array.isArray(data) || data.length === 0) return data;

    return data.map((item) => {
      if (typeof item !== "object" || item === null) return item;

      const processed = { ...item };

      // Process all properties that might contain numeric values
      Object.keys(processed).forEach((key) => {
        const value = processed[key];

        // Skip non-numeric string keys (like year labels)
        if (isNaN(key) && key !== "year") {
          // Check if value is a numeric string or number
          if (typeof value === "string" && value !== "" && !isNaN(value) && !isNaN(parseFloat(value))) {
            // Convert numeric strings to numbers
            processed[key] = parseFloat(value);
          } else if (typeof value === "number") {
            // Already a number, keep it
            processed[key] = value;
          }
        } else if (!isNaN(key)) {
          // Year keys (2018, 2019, etc.) - ensure values are numbers
          if (typeof value === "string" && value !== "" && !isNaN(value) && !isNaN(parseFloat(value))) {
            processed[key] = parseFloat(value);
          }
        }

        // Handle common numeric field names
        const numericFields = [
          "emp_count",
          "male",
          "female",
          "male_highschool",
          "female_bachelor",
          "growth_percent",
          "male_to_female_ratio",
          "male_percent",
          "female_percent",
          "emp_2018",
          "emp_2024",
          "white_alone_emp",
        ];

        numericFields.forEach((field) => {
          if (processed[field] !== undefined) {
            if (typeof processed[field] === "string" && processed[field] !== "" && !isNaN(processed[field]) && !isNaN(parseFloat(processed[field]))) {
              processed[field] = parseFloat(processed[field]);
            }
          }
        });
      });

      return processed;
    });
  };

  useEffect(() => {
    axios
      .get(config.APP_URL + "/cn/cn_verticals")
      .then((response) => {
        if (response.data.success) {
          set_data_cv_q1(processNumericData(response.data.data.data_cv_q1));
          set_data_cv_q2(processNumericData(response.data.data.data_cv_q2));
          set_data_cv_q3(processNumericData(response.data.data.data_cv_q3));
          set_data_cv_q4(processNumericData(response.data.data.data_cv_q4));
          set_data_cv_q5(processNumericData(response.data.data.data_cv_q5));
          set_data_cv_q6(processNumericData(response.data.data.data_cv_q6));
          set_data_cv_q7(processNumericData(response.data.data.data_cv_q7));
          set_data_cv_q8(processNumericData(response.data.data.data_cv_q8));
          set_data_cv_q9(processNumericData(response.data.data.data_cv_q9));
          set_data_cv_q10(processNumericData(response.data.data.data_cv_q10));
          set_data_cv_q11(processNumericData(response.data.data.data_cv_q11));
          set_data_cv_q12(processNumericData(response.data.data.data_cv_q12));
          set_data_cv_q13(processNumericData(response.data.data.data_cv_q13));
          set_data_cv_q14(processNumericData(response.data.data.data_cv_q14));
          set_data_cv_q15(processNumericData(response.data.data.data_cv_q15));
          set_data_cv_q16(processNumericData(response.data.data.data_cv_q16));
          set_data_cv_q17(processNumericData(response.data.data.data_cv_q17));
          set_data_cv_q18(processNumericData(response.data.data.data_cv_q18));
          set_data_cv_q19(processNumericData(response.data.data.data_cv_q19));
          set_data_cv_q20(processNumericData(response.data.data.data_cv_q20));
          set_data_cv_q21(processNumericData(response.data.data.data_cv_q21));
          set_data_cv_q22(processNumericData(response.data.data.data_cv_q22));
          set_data_cv_q23(processNumericData(response.data.data.data_cv_q23));
          set_data_cv_q24(processNumericData(response.data.data.data_cv_q24));
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    const question = searchParams.get("question");

    if (tab) setActiveTab(tab);
    if (question) setExpandedQuestion(decodeURIComponent(question));
  }, [location.search]);

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
    setExpandedQuestion(null); // Reset expanded question when switching tabs
  };

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen7, setIsOpen7] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);
  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);

  const [isOpen17, setIsOpen17] = useState(false);
  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);
  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);
  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);
  const [isOpen24, setIsOpen24] = useState(false);

  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);

  const isOpenStates = [
    setIsOpen1,
    setIsOpen2,
    setIsOpen3,
    setIsOpen4,
    setIsOpen5,
    setIsOpen6,
    setIsOpen7,
    setIsOpen8,
    setIsOpen9,
    setIsOpen10,
    setIsOpen11,
    setIsOpen12,
    setIsOpen13,
    setIsOpen14,
    setIsOpen15,
    setIsOpen16,
    setIsOpen17,
    setIsOpen18,
    setIsOpen19,
    setIsOpen20,
    setIsOpen21,
    setIsOpen22,
    setIsOpen23,
    setIsOpen24,
  ];

  const handleSetOpen = (openIndex, currentOpenIndex) => {
    if (openIndex === currentOpenIndex) {
      // If already open, close all
      isOpenStates.forEach((setFn) => setFn(false));
    } else {
      // Close all, then open selected
      isOpenStates.forEach((setFn, i) => {
        setFn(i === openIndex - 1);
      });
    }
  };

  return (
    <div className="w-[95vw] sm:w-[90vw] h-auto p-1 justify-center items-center mx-auto max-w-full overflow-hidden">
      <Tabs
        id="controlled-tab-example"
        className="tabs"
        activeKey={activeTab}
        onSelect={handleTabSelect}
      >
        {/* employment trend */}
        <Tab
          eventKey="Employment-Trend"
          title="Employment Trend"
          id="Employment-Trend"
        >
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the total employment for Construction Industry  for each year from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(1, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 1 ? null : 1);
                setExpandedQuestion(
                  "1. What is the total employment for Construction Industry  for each year from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the total employment for Construction Industry for
                  each year from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 1 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable1 data={data_cv_q1} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="2. What trends are observed in the employment of female workers in the Construction Industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(2, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 2 ? null : 2);
                setExpandedQuestion(
                  "2. What trends are observed in the employment of female workers in the Construction Industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What trends are observed in the employment of female
                  workers in the Construction Industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 2 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable2 data={data_cv_q2} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="3. What is the quarterly employment trend for 'Male' employees in the Construction Industry?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(3, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 3 ? null : 3);
                setExpandedQuestion(
                  "3. What is the quarterly employment trend for 'Male' employees in the Construction Industry?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the quarterly employment trend for 'Male' employees
                  in the Construction Industry ?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 3 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable3 data={data_cv_q3} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. How does the employment in "Residential Building Construction" compare to "Nonresidential Building Construction" over the years?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(4, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 4 ? null : 4);
                setExpandedQuestion(
                  '4. How does the employment in "Residential Building Construction" compare to "Nonresidential Building Construction" over the years?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. How does the employment in "Residential Building
                  Construction" compare to "Non residential Building
                  Construction" over the years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 4 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable4 data={data_cv_q4} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. Which industries experienced the most significant growth in employment from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(5, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 5 ? null : 5);
                setExpandedQuestion(
                  "5. Which industries experienced the most significant growth in employment from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. Which industries experienced the most significant growth in
                  employment from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 5 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <ConstructionTable5 data={data_cv_q5} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. What is the ratio of male to female employees across all industries in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(6, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 6 ? null : 6);
                setExpandedQuestion(
                  "6. What is the ratio of male to female employees across all industries in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. What is the ratio of male to female employees across all
                  industries in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 6 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <ConstructionTable6 data={data_cv_q6} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Age Analysis */}
        <Tab eventKey="Age-Analysis" title="Age Analysis" id="Age-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the distribution of employment across different age groups from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 7 ? null : 7);
                setExpandedQuestion(
                  "1. What is the distribution of employment across different age groups from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the distribution of employment across different age
                  groups from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 7 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable7 data={data_cv_q7} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='2. How has the employment of individuals in the "65-99" age group changed over time?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 8 ? null : 8);
                setExpandedQuestion(
                  '2. How has the employment of individuals in the "65-99" age group changed over time?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. How has the employment of individuals in the "65-99" age
                  group changed over time?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 8 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable8 data={data_cv_q8} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='3. What are the  employment by industries for individuals in the "25-34" age group in "Utah, UT" for the year 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 9 ? null : 9);
                setExpandedQuestion(
                  '3. What are the  employment by industries for individuals in the "25-34" age group in "Utah, UT" for the year 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What are the employment by industries for individuals in
                  the "25-34" age group in "Utah, UT" for the year 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 9 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable9 data={data_cv_q9} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. What is the employment count for different age groups in the "Other Specialty Trade Contractors" industry?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 10 ? null : 10);
                setExpandedQuestion(
                  '4. What is the employment count for different age groups in the "Other Specialty Trade Contractors" industry?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the employment count for different age groups in
                  the "Other Specialty Trade Contractors" industry?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 10 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable10 data={data_cv_q10} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="5. What is the total number of 'Female' employees in the '14-18' age group across all quarters?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 11 ? null : 11);
                setExpandedQuestion(
                  "5. What is the total number of 'Female' employees in the '14-18' age group across all quarters?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. What is the total number of 'Female' employees in the
                  '14-18' age group across all quarters?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 11 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable11 data={data_cv_q11} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. What is the percentage share of males and females in each age group during 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 12 ? null : 12);
                setExpandedQuestion(
                  "6. What is the percentage share of males and females in each age group during 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. What is the percentage share of males and females in each
                  age group during 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 12 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable12 data={data_cv_q12} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Education Analysis */}
        <Tab
          eventKey="Education-Analysis"
          title="Education Analysis"
          id="Education-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey='1. How does the employment of individuals with "Less than high school" education compare to those with "High school or equivalent, no college"  from 2018 to 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 13 ? null : 13);
                setExpandedQuestion(
                  '1. How does the employment of individuals with "Less than high school" education compare to those with "High school or equivalent, no college"  from 2018 to 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. How does the employment of individuals with "Less than high
                  school" education compare to those with "High school or
                  equivalent, no college" from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 13 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable13 data={data_cv_q13} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='2. Which industries experienced the most significant growth in employment for individuals with "Some college or Associate degree" from 2018 to 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 14 ? null : 14);
                setExpandedQuestion(
                  '2. Which industries experienced the most significant growth in employment for individuals with "Some college or Associate degree" from 2018 to 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. Which industries experienced the most significant growth in
                  employment for individuals with "Some college or Associate
                  degree" from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 14 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable14 data={data_cv_q14} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='3. What is the total employment for individuals with "Less than high school" education in each industry for the year 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 15 ? null : 15);
                setExpandedQuestion(
                  '3. What is the total employment for individuals with "Less than high school" education in each industry for the year 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the total employment for individuals with "Less
                  than high school" education in each industry for the year
                  2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 15 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable15 data={data_cv_q15} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. What is the percentage of employees with a "Bachelor" degree for each year from 2018 to 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 16 ? null : 16);
                setExpandedQuestion(
                  '4. What is the percentage of employees with a "Bachelor" degree for each year from 2018 to 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the percentage of employees with a "Bachelor"
                  degree for each year from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 16 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable16 data={data_cv_q16} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='5. How does the total employment for males with "High school or equivalent, no college" compare to females with a "Bachelor" degree on a year-by-year basis ?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 17 ? null : 17);
                setExpandedQuestion(
                  '5. How does the total employment for males with "High school or equivalent, no college" compare to females with a "Bachelor" degree on a year-by-year basis ?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How does the total employment for males with "High school
                  or equivalent, no college" compare to females with a
                  "Bachelor" degree on a year-by-year basis ?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 17 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable17 data={data_cv_q17} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="6. For all industries combined, what is the employment breakdown by education for each quarter?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 18 ? null : 18);
                setExpandedQuestion(
                  "6. For all industries combined, what is the employment breakdown by education for each quarter?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. For all industries combined, what is the employment
                  breakdown by education for each quarter?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 18 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable18 data={data_cv_q18} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Race Analysis */}
        <Tab eventKey="Race-Analysis" title="Race Analysis" id="Race-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="1. What is the total employment for each race group across all Construction industries?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 19 ? null : 19);
                setExpandedQuestion(
                  "1. What is the total employment for each race group across all Construction industries?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the total employment for each race group across all
                  Construction industries?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 19 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable19 data={data_cv_q19} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='2. What is the total employment for "White Alone" employees over the years?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 20 ? null : 20);
                setExpandedQuestion(
                  '2. What is the total employment for "White Alone" employees over the years?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the total employment for "White Alone" employees
                  over the years?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 20 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable20 data={data_cv_q20} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='3. What is the employee count of "Asian Alone" employees in each industry in 2024?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 21 ? null : 21);
                setExpandedQuestion(
                  '3. What is the employee count of "Asian Alone" employees in each industry in 2024?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the employee count of "Asian Alone" employees in
                  each industry in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 21 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable21 data={data_cv_q21} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='4. What is the breakdown of employment by race for "Utility System Construction"?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 22 ? null : 22);
                setExpandedQuestion(
                  '4. What is the breakdown of employment by race for "Utility System Construction"?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the breakdown of employment by race for "Utility
                  System Construction"?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 22 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable22 data={data_cv_q22} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='5. How does employment for "Two or More Race Groups" change over time in "Washington, UT"?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 23 ? null : 23);
                setExpandedQuestion(
                  '5. How does employment for "Two or More Race Groups" change over time in "Washington, UT"?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How does employment for "Two or More Race Groups" change
                  over time in "Washington, UT"?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 23 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <ConstructionTable23 data={data_cv_q23} />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey='6. How does the number of "American Indian or Alaska Native Alone" employees in "Salt Lake, UT" changed over time?'
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 24 ? null : 24);
                setExpandedQuestion(
                  '6. How does the number of "American Indian or Alaska Native Alone" employees in "Salt Lake, UT" changed over time?'
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. How does the number of "American Indian or Alaska Native
                  Alone" employees in "Salt Lake, UT" changed over time?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 24 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {" "}
                <ConstructionTable24 data={data_cv_q24} />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};
